import createCachedSelector from 're-reselect';

import { BettingEntitiesSelectors } from 'app/lib/betting/betting-entities';
import { orderByGlobalPriority } from 'app/lib/grid';
import { sortByPriority } from 'app/lib/sortByPriorityImmutableData';

export default (
  matches: BettingEntitiesSelectors['matches'],
  getUnionsFromSportsSelector: BettingEntitiesSelectors['getUnionsFromSportsSelector'],
  tournaments: BettingEntitiesSelectors['tournaments'],
) => {
  return createCachedSelector(
    matches,
    getUnionsFromSportsSelector,
    tournaments,
    (matchesById, tournamentUnions, tournaments) => {
      if (!tournaments) {
        return new Map();
      }

      const sortedUnions = sortByPriority(tournamentUnions);

      return sortedUnions.reduce((result, union) => {
        const unionTournaments = tournaments.filter((t) => t.tournamentUnionId === union.id);

        const sortedTournaments = sortByPriority(unionTournaments);

        return sortedTournaments.reduce((result, tournament) => {
          return result
            .set(
              tournament.id,
              new Set(orderByGlobalPriority(matchesById, [...tournament.matchIds])));
        }, result);
      }, new Map());
    },
  )((_state, sportId) => sportId);
};
